EMMY.ballotFilter = {
  init: function () {
    if($('.search-table').val() != undefined) {
      var parameterVals = window.location.search;
      localStorage.setItem('searchURL', parameterVals);
      $('.clear-button').on('click', function () {
        localStorage.removeItem('searchURL');
      });
    }

    var inputWidth = $('.entries-table').width();

    $('#years').on('change', function(e) {
      var year = $(this).val();
      window.location.href = window.location.pathname + "?years[]="+year;
    });

      $('#year').on('change', function(e) {
          var year = $(this).val();
          window.location.href = window.location.pathname + "?year="+year;
      });

    $('select').on('select2:open', function(e) {
      $(this).closest('.choices-filter-group').find('.selection').addClass('rad-dropSelect');
      if($(this).attr('id') == 'categories') {
        $('.searchAdmin').addClass('fullWidthSearch');
        $('.fullWidthSearch .rad-dropSelect').css('width', inputWidth);
        $('.fullWidthSearch.reportProofHairMakeup .rad-dropSelect').css('width', 600);
        $('.fullWidthSearch > .select2-container .select2-dropdown').css('width', inputWidth);
      }
    });
    $('select').on('select2:close', function(e) {
      $(this).closest('.choices-filter-group').find('.selection').removeClass('rad-dropSelect');
      if($(this).attr('id') == 'categories') {
        $('.searchAdmin').removeClass('fullWidthSearch');
      }
    });

      $('.choices-filter-group select').each(function () {
        var selectLabel = $(this).closest('.choices-filter-group').find('h4').text();
        $(this).closest('.choices-filter-group').find('.dropdown-wrapper').text(selectLabel);

        var filterGrouping = 'filter-tags-' + $(this).attr('id');
        var that = $(this);
        _setOptionasButton(that, filterGrouping);
        $(this).on('change', function (e) {
          var that2 = $(this);
          _setOptionasButton(that, filterGrouping);
        });
      });
      $('body').on('click', '.name2', function(e) {
        var valueSelected = this.getAttribute('data-filter');
        var idVal = $(this).parent().attr('class').replace('filter-tags-','');
        var that = $('#' + idVal);
        _removeItem(that, valueSelected);
        $(this).remove();
      });

      $(document).on('click', '.statuette-signout-button', function(e) {
          if($('#show_type').val() == 'all') {
              e.preventDefault();
              alert('Please select a Show Type first.')
          }
      })

  },
};
